|<template>
    <v-dialog v-model="localShowHistory" max-width="900px" transition="dialog-bottom-transition">
        <v-card class="history-card">

            <!-- HEADER -->
            <v-card-title class="history-header">
                <v-icon left color="white">mdi-clipboard-list-outline</v-icon>
                Historial de Productos
            </v-card-title>
            <v-divider></v-divider>

            <v-card-text class="pa-6">

                <!-- BUSCADOR -->
                <v-text-field
                    v-model="historySearch"
                    append-icon="mdi-magnify"
                    label="Buscar en historial"
                    dense
                    hide-details
                    class="history-search mb-6"
                ></v-text-field>

                <!-- TABLA -->
                <v-data-table
                    :headers="historyHeaders"
                    :items="closedPortafolio"
                    :search="historySearch"
                    :items-per-page="10"
                    class="history-table elevation-0"
                    dense
                >
                    <template v-slot:[`item.initialAmount`]="{ item }">
                      {{ formatCurrency(item.initialAmount) }}
                    </template>

                    <template v-slot:[`item.interestRate`]="{ item }">
                      {{ item.interestRate }}%
                    </template>

                    <template v-slot:[`item.endDate`]="{ item }">
                      {{ formatDateNumeric(item.endDate) }}
                    </template>

                    <template v-slot:no-data>
                    <div class="text-center grey--text my-4">
                        No hay productos en el historial.
                    </div>
                    </template>
                </v-data-table>

            </v-card-text>

            <!-- FOOTER -->
            <v-card-actions class="justify-end pb-4 pr-4">
                <v-btn color="primary" text @click="localShowHistory = false">
                    Cerrar
                </v-btn>
            </v-card-actions>

        </v-card>
    </v-dialog>
</template>

<script>
import productMixin from '../../mixins/productMixin'
export default {
  name: 'ProductHistory',
  mixins: [productMixin],
  props: {
    showHistory: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      localShowHistory: this.showHistory,
      historySearch: '',
      historyHeaders: [
        { text: 'Producto', value: 'product.name', sortable: true },
        { text: 'Folio', value: 'folio', sortable: true },
        { text: 'Monto', value: 'initialAmount', sortable: true },
        { text: 'Moneda', value: 'currency', sortable: true },
        { text: 'Tasa de Interés', value: 'interestRate', sortable: true },
        { text: 'Fecha Fin', value: 'endDate', sortable: true }
      ]
    }
  },
  watch: {
    // two-way binding
    showHistory (val) {
      this.localShowHistory = val
    },

    localShowHistory (val) {
      this.$emit('update:showHistory', val)
    }
  }
}
</script>

<style scoped>
.history-header {
  background: #324A74;
  color: white !important;
  font-size: 1.2rem;
  font-weight: 700;
  padding: 16px 20px;
  letter-spacing: .4px;
  display: flex;
  align-items: center;
}

.history-search {
  --v-text-field-border-color: #CBD5E1 !important;
}

.history-search input {
  background: #F1F5F9 !important;
  border-radius: 10px !important;
}

.history-table {
  border-radius: 10px;
}

.history-table .v-data-table__wrapper tr {
  transition: background .2s ease;
}

.history-table .v-data-table__wrapper tr:hover {
  background-color: #F5F7FA !important;
}

</style>
